export enum FeatureFlagKeysEnum {
  NATIVE_UPDATE_REQUIRED = 'native-update-required',
}
